<template>
    <div class="p-t-xs-20 p-b-xs-20">
        <div v-if="order && cart && receipt" class="container-fluid">
            <div v-if="loading" class="ak-data-table__loading-message">
                <ak-loader
                        :static="true"
                        :loading="loading"
                        size="small"
                        class="ak-data-table__loader"
                />
                <div>
                    Gegevens ophalen
                </div>
            </div>
            <div class="row" v-if="!loading">
                <div class="col-lg-12" style="display: flex;justify-content: space-between">
                    <div class="m-b-xs-20">
                        <ak-button
                                size="small"
                                @click="backToOrders"
                                style="vertical-align: top;"
                        >
                            <i class="ak-icon ak-button__icon">arrow_left</i>
                            {{ $t('Ga terug') }}
                        </ak-button>
                        <template
                                v-if="order.isInvoice && !order.isStatusApproved && !order.cancelled && order.paymentStatus !== 1">
                            <ak-button
                                    size="small"
                                    style="vertical-align: bottom;"
                                    @click="openOrderDefinitionForm('item-form')"
                            >
                                {{ $t('Artikelen aanpassen') }}
                            </ak-button>
                            <ak-button
                                    size="small"
                                    colorMode="danger"
                                    style="vertical-align: bottom;"
                                    @click="showConfirm = true"
                            >
                                {{ $t('Bestelling annulleren') }}
                            </ak-button>
                        </template>
                    </div>
                    <div class="m-b-xs-20">
                        <ak-button
                                v-if="prev"
                                size="small"
                                @click="goPrev"
                                style="vertical-align: top;"
                        >
                            <i class="ak-icon ak-button__icon">arrow_left</i>
                            {{ $t('Vorige') }}
                        </ak-button>
                        <ak-button
                                v-if="next"
                                size="small"
                                @click="goNext"
                                style="vertical-align: bottom;"
                        >
                            {{ $t('Volgende') }}
                            <i class="ak-icon ak-button__icon">arrow_right</i>
                        </ak-button>
                    </div>
                </div>
                <div class="col-lg-8">
                    <div class="ak-panel ak-panel--no-padding m-b-xs-20">
                        <div class="ak-panel__header ak-panel__header--small">
                            <div class="ak-panel__title">
                                {{ $t('Bestelling') }}
                            </div>
                            <strong class="m-l-auto">{{ cart.code }}</strong>
                        </div>
                        <div v-if="order.externalOrderId" class="ak-panel__body">
                            {{ $t('Extern bestelnummer') }}: <strong>{{ order.externalOrderId }}</strong>
                        </div>
                        <table class="ak-table ak-panel__table">
                            <thead>
                            <tr class="ak-table-row">
                                <th class="ak-table-head">
                                    {{ $t('Artikel nummer	') }}
                                </th>
                                <th class="ak-table-head">
                                    {{ $t('Artikel') }}
                                </th>
                                <th class="ak-table-head">
                                    {{ $t('Aantal') }}
                                </th>
                                <th class="ak-table-head">
                                    {{ $t('Aantal picked/bo') }}
                                </th>
                                <th class="ak-table-head">
                                    {{ $t('Prijs') }}
                                </th>
                                <th class="ak-table-head">
                                    &nbsp;
                                </th>
                            </tr>
                            </thead>
                            <tbody class="ak-table-body">
                            <tr v-for="(line, lineId) in receipt.items" class="ak-table-row">
                                <td :class="{'ak-table-column--warning': hasBo(line, lineId)}"
                                    class="ak-table-column">{{ line.code }}
                                </td>
                                <td :class="{'ak-table-column--warning': hasBo(line, lineId)}"
                                    class="ak-table-column">
                                    <a v-if="line.previewHref" :href="line.previewHref"
                                       class="ak-link ak-link--uppercase" target="_blank" v-html="line.title">

                                    </a>
                                    <span v-else v-html="line.title">

                                        </span>
                                </td>
                                <td :class="{'ak-table-column--warning': hasBo(line, lineId)}"
                                    class="ak-table-column">{{ line.quantity }}
                                </td>
                                <td :class="{'ak-table-column--warning': hasBo(line, lineId)}"
                                    class="ak-table-column">
                                    {{ (getPickingItem(line, lineId) && getPickingItem(line, lineId).picked) || 0 }} /
                                    <span :class="{'text--color-warning text--bold': hasBo(line, lineId)}">{{
                                            (getPickingItem(line, lineId) && getPickingItem(line, lineId).bo) || 0
                                        }}</span>
                                </td>
                                <td :class="{'ak-table-column--warning': hasBo(line, lineId)}"
                                    class="ak-table-column">{{ line.amount.formatted }}
                                </td>
                                <td :class="{'ak-table-column--warning': hasBo(line, lineId)}"
                                    class="ak-table-column">
                                    <ak-popover-menu
                                            v-if="!hasPickingItems || (line.quantity > ((getPickingItem(line, lineId) && getPickingItem(line, lineId).picked) || 0) && ((getPickingItem(line, lineId) && getPickingItem(line, lineId).bo) || 0))"
                                            direction="right"
                                    >
                                        <template v-slot:trigger="{open:open, toggleMenu:toggleMenu}">
                                            <ak-button
                                                    class="ak-table__contextual-trigger"
                                                    size="x-small"
                                                    :active="open"
                                                    :disableBackground="true"
                                                    colorMode="text"
                                                    @click="toggleMenu"
                                            >
                                                <i class="ak-icon ak-icon--large ak-icon--bolt">
                                                    more_horiz
                                                </i>
                                            </ak-button>
                                        </template>
                                        <template v-slot:default>
                                            <ak-widget
                                                    key="cancel"
                                                    type="ak-popover-menu-item"
                                                    :attributes="{title: 'Annuleer niet geleverde items', id: 'cancel', showArrow: false}"
                                                    :objectId="lineId"
                                                    class="ma-2"
                                                    :active="openMenu"
                                                    @click="cancelLine(lineId)"
                                            />
                                        </template>
                                    </ak-popover-menu>
                                </td>
                            </tr>
                            <tr v-for="line in receipt.lines" class="ak-table-row">
                                <td class="ak-table-column"></td>
                                <td class="ak-table-column"></td>
                                <td class="ak-table-column"></td>
                                <td class="ak-table-column text--right" v-html="line.title"></td>
                                <td class="ak-table-column">{{ line.amount.formatted }}</td>
                                <td class="ak-table-column"></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="ak-panel m-b-xs-20  ak-panel--no-padding">
                        <div class="ak-panel__header ak-panel__header--small">
                            <div class="ak-panel__title">
                                {{ $t('Betaling') }}
                            </div>
                        </div>
                        <table v-if="order.paymentStatus === 1" class="ak-table ak-panel__table">
                            <tbody class="ak-table-body">
                            <tr class="ak-table-row">
                                <td class="ak-table-column">
                                    {{ $t('Betaling ontvangen') }}
                                </td>
                            </tr>
                            <tr v-if="inspector.paymentType" class="ak-table-row">
                                <td class="ak-table-column">
                                    {{ inspector.paymentType.title }}
                                </td>
                            </tr>
                            <tr v-if="order.externalPaymentId" class="ak-table-row">
                                <td class="ak-table-column">
                                    {{ $t('Externe betalings-id') }}: <strong>{{ order.externalPaymentId }}</strong>
                                </td>
                            </tr>
                            <tr v-if="order.paymentCardHolderName" class="ak-table-row">
                                <td class="ak-table-column">
                                    {{ order.paymentCardHolderName }}
                                </td>
                            </tr>
                            <tr v-if="order.getPaymentCardNumber" class="ak-table-row">
                                <td class="ak-table-column">
                                    {{ order.getPaymentCardNumber }}
                                    <div v-if="order.paymentCardExpirationMonthAndYear">
                                        {{ $t('Vervaldatum') }} {{ order.paymentCardExpirationMonthAndYear }}
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="order.paymentMessage" class="ak-table-row">
                                <td class="ak-table-column">
                                    {{ order.paymentMessage }}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <table v-else-if="!order.cancelled" class="ak-table ak-panel__table">
                            <tbody class="ak-table-body">
                            <tr class="ak-table-row">
                                <td class="ak-table-column">
                                    {{ $t('Betaling openstaande') }}
                                </td>
                            </tr>
                            <tr v-if="order.paymentMessage" class="ak-table-row">
                                <td class="ak-table-column">
                                    {{ order.paymentMessage }}
                                </td>
                            </tr>
                            <tr class="ak-table-row">
                                <td class="ak-table-column">
                                    <ak-button @click="openOrderDefinitionForm('payment-form')">
                                        {{ $t('Markeren als betaald') }}
                                    </ak-button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                    <div v-if="order.comments" class="ak-panel ak-panel--no-padding m-b-xs-20">
                        <div class="ak-panel__header ak-panel__header--small">
                            <div class="ak-panel__title">
                                {{ $t('Opmerkingen') }}
                            </div>
                        </div>
                        <div class="ak-panel__body">
                            {{ order.comments }}
                        </div>
                    </div>

                    <div class="ak-panel ak-panel--no-padding m-b-xs-20">
                        <div class="ak-panel__header ak-panel__header--small">
                            <div class="ak-panel__title">
                                {{ $t('Historiek') }}
                            </div>
                        </div>
                        <table class="ak-table ak-panel__table">
                            <thead>
                            <tr class="ak-table-row">
                                <th class="ak-table-head">
                                    {{ $t('Datum') }}
                                </th>
                                <th class="ak-table-head">
                                    {{ $t('Gebeurtenis') }}
                                </th>
                            </tr>
                            </thead>
                            <tbody class="ak-table-body">
                            <tr v-for="history in order.orderHistory"
                                class="ak-table-row">
                                <td class="ak-table-column">{{ history.createdAt | datetime }}</td>
                                <td class="ak-table-column">
                                    <a v-if="history.href" :href="history.href" target="_blank">
                                        {{ history.event }}
                                    </a>
                                    <template v-else>
                                        <span v-html="history.event"></span>
                                    </template>
                                </td>
                            </tr>
                            <tr class="ak-table-row">
                                <td class="ak-table-column">{{ cart.date | datetime }}</td>
                                <td class="ak-table-column">{{ $t('Creatie winkelmandje') }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="ak-panel ak-panel--no-padding  m-b-xs-20">
                        <div class="ak-panel__header ak-panel__header--small">
                            <div class="ak-panel__title">
                                {{ $t('Interne opmerkingen') }}
                            </div>
                        </div>
                        <div class="ak-panel__body ak-panel__body--small reading">
                            <p v-if="order.internalComments" v-html="order.internalComments">
                            </p>
                            <ak-button @click="openOrderDefinitionForm('internal-comments-form')">
                                {{ $t('Opmerking toevoegen') }}
                            </ak-button>
                        </div>
                    </div>
                    <div class="ak-panel ak-panel--no-padding  m-b-xs-20" v-if="isAdmin">
                        <div class="ak-panel__header ak-panel__header--small">
                            <div class="ak-panel__title">
                                {{ $t('Interne admin opmerkingen') }}
                            </div>
                        </div>
                        <div class="ak-panel__body ak-panel__body--small reading">
                            <p v-if="order.internalAdminComments" v-html="order.internalAdminComments">
                            </p>
                            <ak-button @click="openOrderDefinitionForm('internal-admin-comments-form')">
                                {{ $t('Opmerking toevoegen') }}
                            </ak-button>
                        </div>
                    </div>
                    <div class="ak-panel ak-panel--no-padding  m-b-xs-20">
                        <div class="ak-panel__header ak-panel__header--small">
                            <div class="ak-panel__title">
                                {{ $t('Persoonlijke gegevens') }}
                            </div>
                        </div>
                        <div class="ak-panel__body ak-panel__body--small reading">
                            <p>
                                <strong>{{ cartDetails.firstName }} {{ cartDetails.surname }}</strong><br>
                            </p>
                            <p v-if="cartDetails.streetName || cartDetails.streetNumber || cartDetails.boxNumber || cartDetails.postalCode || cartDetails.city || cartDetails.countryIso">
                                {{ cartDetails.streetName }} {{ cartDetails.streetNumber }}
                                {{ cartDetails.boxNumber }}<br>
                                {{ cartDetails.postalCode }} {{ cartDetails.city }} {{ cartDetails.countryIso }}
                            </p>
                            <p>
                                {{ cartDetails.phone }}<br>
                                <a :href="'mailto:'+cartDetails.email">{{ cartDetails.email }}</a>
                            </p>
                        </div>
                    </div>
                    <div class="ak-panel ak-panel--no-padding  m-b-xs-20" v-if="order.customerOrganisation || order.customerOrganisationName">
                        <div class="ak-panel__header ak-panel__header--small">
                            <div class="ak-panel__title">
                                {{ $t('Klantgegevens') }}
                            </div>
                        </div>
                        <div class="ak-panel__body ak-panel__body--small reading">
                            <p>
                                <strong>{{ order.customerOrganisationObject ? order.customerOrganisationObject.name : order.customerOrganisationName }}</strong><br>
                                <strong v-if="order.customerOrganisationType"> {{ order.customerOrganisationType }} </strong>
                            </p>
                            <p v-if="order.customerStreetAddress || order.customerStreetNumber || order.customerBoxNumber || order.customerPostalCode || order.customerCity || order.customerCountryIso">
                                {{ order.customerStreetAddress }} {{ order.customerStreetNumber }}
                                {{ order.customerBoxNumber }}<br>
                                {{ order.customerPostalCode }} {{ order.customerCity }} {{ order.customerCountryIso }}
                            </p>
                        </div>
                    </div>
                    <div class="ak-panel ak-panel--no-padding  m-b-xs-20">
                        <div class="ak-panel__header ak-panel__header--small">
                            <div class="ak-panel__title">
                                {{ $t('Factuuradres') }}
                            </div>
                        </div>
                        <div class="ak-panel__body ak-panel__body--small reading">
                            <p>
                                <strong>{{ order.invoiceFirstName }} {{ order.invoiceSurnames }}</strong><br>
                                <strong v-if="order.invoiceCompanyName"> {{ order.invoiceCompanyName }} </strong><br>
                                <span v-if="order.invoiceVat"> {{ order.invoiceVat }}</span><br>
                                <span v-if="order.invoiceReference">Ref. {{ order.invoiceReference }}</span>
                            </p>
                            <p v-if="order.invoiceStreetAddress || order.invoiceStreetNumber || order.invoiceBoxNumber || order.invoicePostalCode || order.invoiceCity || order.invoiceCountryIso">
                                {{ order.invoiceStreetAddress }} {{ order.invoiceStreetNumber }}
                                {{ order.invoiceBoxNumber }}<br>
                                {{ order.invoicePostalCode }} {{ order.invoiceCity }} {{ order.invoiceCountryIso }}
                            </p>
                            <p>
                                {{ order.invoicePhone }}<br>
                                <a v-if="order.invoiceEmail" :href="'mailto:' + order.invoiceEmail">
                                    {{ order.invoiceEmail }}
                                </a>
                            </p>
                        </div>
                    </div>
                    <div class="ak-panel ak-panel--no-padding m-b-xs-20">
                        <div class="ak-panel__header ak-panel__header--small">
                            <div class="ak-panel__title">
                                {{ $t('Leveringsgegevens') }}
                            </div>
                            <i v-if="order.hasSuspiciousShippingAddress"
                               class="ak-icon text--color-warning"
                               style="margin-left: 8px"
                               :title="$t('Leveringsadres controleren')"
                               :aria-label="$t('Leveringsadres controleren')">warning</i>
                            <strong class="m-l-auto">
                                    <span v-if="order.shippingTypeId === 1">
                                        {{ $t('Afhalen') }}
                                    </span>
                                <span v-else>
                                        {{ $t('Leveren') }}
                                    </span>
                            </strong>
                        </div>
                        <table class="ak-table ak-panel__table">
                            <tbody class="ak-table-body">
                            <tr v-if="order.shippingCompanyName && !order.shippingName && !order.shippingReceiverName">
                                <td class="ak-table-column">
                                    <strong>{{ $t('Bedrijf:') }}</strong>
                                </td>
                                <td class="ak-table-column">
                                    {{ order.shippingCompanyName }}
                                </td>
                            </tr>
                            <tr v-if="order.shippingFirstName" class="ak-table-row">
                                <td class="ak-table-column">
                                    <strong>{{ $t('Voornaam:') }}</strong>
                                </td>
                                <td class="ak-table-column">
                                    {{ order.shippingFirstName }}
                                </td>
                            </tr>
                            <tr v-if="order.shippingSurnames" class="ak-table-row">
                                <td class="ak-table-column">
                                    <strong>{{ $t('Achternaam:') }}</strong>
                                </td>
                                <td class="ak-table-column">
                                    {{ order.shippingSurnames }}
                                </td>
                            </tr>
                            <tr v-if="order.shippingName" class="ak-table-row">
                                <td class="ak-table-column">
                                    <strong>{{ $t('Naam:') }}</strong>
                                </td>
                                <td class="ak-table-column">
                                    {{ order.shippingName }}
                                </td>
                            </tr>
                            <tr v-if="order.shippingReceiverName" class="ak-table-row">
                                <td class="ak-table-column">
                                    <strong>{{ $t('Ontvanger naam:') }}</strong>
                                </td>
                                <td class="ak-table-column">
                                    {{ order.shippingReceiverName }}
                                </td>
                            </tr>
                            <tr v-if="order.shippingEmail" class="ak-table-row">
                                <td class="ak-table-column">
                                    <strong>{{ $t('E-mailadres:') }}</strong>
                                </td>
                                <td class="ak-table-column">
                                    <a :href="'mailto:' + order.shippingEmail">
                                        {{ order.shippingEmail }}
                                    </a>
                                </td>
                            </tr>
                            <tr v-if="order.shippingStreetAddress || order.shippingStreetNumber || order.shippingBoxNumber || order.shippingPostalCode || order.shippingCity || order.shippingCountryIso"
                                class="ak-table-row">
                                <td class="ak-table-column">
                                    <strong>{{ $t('Adres:') }}</strong>
                                </td>
                                <td class="ak-table-column">
                                    {{ order.shippingStreetAddress }} {{ order.shippingStreetNumber }}
                                    {{ order.shippingBoxNumber }},
                                    {{ order.shippingPostalCode }} {{ order.shippingCity }}
                                    {{ order.shippingCountryIso }}
                                    <div v-if="order.hasSuspiciousShippingAddress" class="text--color-warning">
                                        <i class="ak-icon" aria-hidden="true">warning</i>
                                        {{ $t('Controleer het leveringsadres: straatnaam en huisnummer lijken verwisseld of dubbel ingevuld.') }}
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="order.requestedDeliveryDate" class="ak-table-row">
                                <td class="ak-table-column">
                                    <strong>{{ $t('Gewenste leveringsdatum:') }}</strong>
                                </td>
                                <td class="ak-table-column">
                                    {{ $moment(order.requestedDeliveryDate).format('DD-MM-YYYY') }}
                                </td>
                            </tr>
                            <tr v-if="hasDateShippingPlanned" class="ak-table-row">
                                <td class="ak-table-column">
                                    <strong>{{ $t('Geplande leveringsdatum:') }}</strong>
                                </td>
                                <td class="ak-table-column">
                                    <template v-for="(orderpicking, key) in order.orderPickings">
                                        <span v-if="orderpicking.dateShippingPlanned">
                                            {{ $moment(orderpicking.dateShippingPlanned).format('DD-MM-YYYY') }}
                                        </span><br/>
                                    </template>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <div v-if="isAdmin && order.canChangeShippingAddress" class="ak-panel__body ak-panel__body--small">
                            <ak-button size="small" @click="openOrderDefinitionForm('delivery-form')">
                                {{ $t('Leveringsadres aanpassen') }}
                            </ak-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <router-view
                name="childview"
                @paymentSaved="paymentSaved"
        />

        <ak-confirm
                v-model="showConfirm"
                :confirmTitle="$t('Ben je zeker?')"
                :confirmText="$t('Ben je zeker dat je deze bestelling wil annuleren?')"
                :confirmLabel="$t('Ja')"
                :cancelLabel="$t('Nee')"
                @confirm="cancelOrder"
                @cancel="showConfirm = false"
        />
    </div>

</template>

<script>
export default {
    name: 'OrderOverview',
    data() {
        return {
            isAdmin: false,
            order: null,
            cart: null,
            inspector: null,
            cartDetails: null,
            receipt: null,
            loading: false,
            showConfirm: false,
            next: null,
            prev: null,
            openMenu: false,
        }
    },
    computed: {
        hasPickingItems() {
            return !!(this.order && this.order.orderPickingItems && Object.keys(this.order.orderPickingItems).length);
        },
        hasDateShippingPlanned() {
            if (!this.order || !this.order.orderPickings || !this.order.orderPickings.length) {
                return false;
            }

            let hasDateShippingPlanned = false;
            this.order.orderPickings.forEach((orderPicking) => {
                if (orderPicking.dateShippingPlanned) {
                    hasDateShippingPlanned = true;
                }
            })

            return hasDateShippingPlanned;
        }
    },
    methods: {
        getPickingItem(line, lineId) {
            return (line && line.picking) || (this.order && this.order.orderPickingItems && this.order.orderPickingItems[lineId]) || {picked: 0, bo: 0};
        },
        hasBo(line, lineId) {
            const pickingItem = this.getPickingItem(line, lineId);
            return !!(pickingItem && pickingItem.bo > 0);
        },
        async getOrder() {
            this.loading = true;
            const result = await this.$get('/order-overview/' + this.$route.params.orderCode);
            this.loading = false;

            if (result.success) {
                this.isAdmin = result.data.isAdmin;
                this.order = result.data.order;
                this.cart = result.data.cart;
                this.receipt = result.data.receipt;
                this.inspector = result.data.inspector;
                this.cartDetails = result.data.cartDetails;
            }
        },
        backToOrders() {
            if (typeof this.$route.query.returnTo === 'string' && this.$route.query.returnTo.startsWith('/picking-v2/')) {
                this.$router.push(this.$route.query.returnTo);
                return;
            }
            this.$router.push({
                name: 'grid',
                params: {
                    bundle: this.$route.params.sourceBundle,
                    gridDefinition: this.$route.params.gridDefinition,
                }
            });
        },
        paymentSaved() {
            this.getOrder();
            this.$router.push({
                name: 'order-overview',
                params: {
                    gridDefinition: this.$route.params.gridDefinition,
                    sourceBundle: this.$route.params.sourceBundle,
                    orderCode: this.cart.code
                }
            });
        },
        openOrderDefinitionForm(definition) {
            this.$router.push({
                name: 'order-overview-form',
                params: {
                    gridDefinition: this.$route.params.gridDefinition,
                    sourceBundle: this.$route.params.sourceBundle,
                    bundle: 'order',
                    orderCode: this.cart.code,
                    definition: definition,
                    objectId: this.order.hashId
                }
            });
        },
        async goNext() {
            await this.$router.push({
                name: 'order-overview',
                params: {
                    gridDefinition: this.$route.params.gridDefinition,
                    sourceBundle: this.$route.params.sourceBundle,
                    orderCode: this.next,
                },
            });
            await this.getOrder();
            this.loading = true;
            await this.getPrevNext();
            this.loading = false;
        },
        async goPrev() {
            await this.$router.push({
                name: 'order-overview',
                params: {
                    gridDefinition: this.$route.params.gridDefinition,
                    sourceBundle: this.$route.params.sourceBundle,
                    orderCode: this.prev,
                },
            });
            await this.getOrder();
            this.loading = true;
            await this.getPrevNext();
            this.loading = false;
        },
        async cancelOrder() {
            this.showConfirm = false;
            this.loading = true;
            const result = await this.$post('/order-cancel/' + this.$route.params.orderCode);
            this.loading = false;

            if (result.success) {
                await this.$router.go();
            }
        },
        getDataFetchParams() {
            const gridId = this.$route.params.sourceBundle + '-' + this.$route.params.gridDefinition;
            const dataFetchParams = JSON.parse(localStorage.getItem(gridId + '-fetch-params'));
            const persistentFiltersCookie = this.$cookies.get(gridId);
            const persistentFilters = persistentFiltersCookie ? JSON.parse(persistentFiltersCookie) : null;

            let allParams = {...dataFetchParams};

            if (persistentFilters && persistentFilters.length !== 0) {
                persistentFilters.forEach((filter, i) => {
                    allParams[`f${i}`] = filter.id;

                    filter.values.forEach((value, key) => {
                        allParams[`v${i}[${key}]`] = value;
                    });
                });
            }

            return allParams;
        },
        async getPrevNext() {
            let params = this.getDataFetchParams();
            const result = await this.$get(`/` + this.$route.params.sourceBundle + `/order-prev-next/` + this.$route.params.orderCode, params);

            this.prev = result.prev
            this.next = result.next
        },
        async cancelLine(lineId) {
            this.showConfirm = false;
            this.loading = true;
            const result = await this.$post('/order-line-cancel/' + this.order.id + '/' + lineId);
            this.loading = false;

            if (result.success) {
                await this.$router.go();
            }
        }
    },
    async created() {
        this.getOrder();
        this.getPrevNext();
        this.loading = false;
    },
}
</script>
